import { useEffect, useState } from "react";

/** Delays picking up a fast-changing value (typically typed input) by `delayMs` of no further change, so a
 * search-as-you-type field fires one request per pause in typing rather than one per keystroke. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
